import React, { Component } from "react";
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/profilepic.jpg" alt="" />
          </div>

          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p>
              Hello! I remember the first PC I owned, it had a white casing and
              ran on MS-DOS. My ten year old brain was fascinated by my father
              typing commands on the monitor. I wanted to know more on how the
              inside of computers work, so after highschool I did a degree in
              Electronics and Telecommunication Engineering. Now I am more
              interested in what can be done with computers, and that's how I
              landed on software engineering. I believe technology can make a
              person's life easier, but with each new development and each new
              feature, it is getting more and more complicated for people to
              handle. I am interested in doing my part to bridge this gap, by
              making good software that is intuitive to everyone.
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>{resumeData.name}</span>
                  <br></br>
                  <span>{resumeData.email}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
